import { z } from "zod";
import { TObjectBase } from "../base";

export const TRawDeviationExternalLink = z
  .object({
    active: z.boolean(),
    title: z.string(),
    tokenID: z.string(),
  })
  .extend(TObjectBase.shape);
